import React from "react";

export default function EtsyIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={24} height={24} y={0.082} fill="#currentColor" rx={12} />
      <path
        fill="#fff"
        d="M10.35 7.201v4.441s1.48 0 2.273-.063c.623-.116.738-.18.853-.838l.229-.964h.678l-.115 2.108.06 2.16h-.683l-.17-.844c-.169-.6-.398-.722-.852-.78-.568-.063-2.273-.063-2.273-.063v3.724c0 .717.344 1.023 1.136 1.023h2.388c.738 0 1.475-.064 1.935-1.201l.618-1.444H17c-.06.3-.344 2.945-.399 3.54 0 0-2.158-.058-3.065-.058H9.442L7 18v-.653l.792-.184c.574-.122.743-.3.743-.78 0 0 .06-1.623.06-4.326 0-2.697-.06-4.32-.06-4.32 0-.537-.169-.659-.743-.78L7 6.78V6.12l2.388.052h4.546c.908 0 2.437-.173 2.437-.173s-.054 1.016-.114 3.419h-.624l-.23-.844c-.223-1.08-.562-1.617-1.19-1.617h-3.574c-.29 0-.29.058-.29.243Z"
      />
    </svg>
  );
}
